'use strict';

define('vb/action/builtin/downloadExtensionsAction',[
  'vb/action/action',
  'vb/private/action/actionHelper',
], (Action, ActionHelper) => {
  /**
   * Downloads extensions to the device from an extension manager. If the extensions are already there on the device,
   * version check is performed to upgrade or download new extensions
   *
   * @param {Object} parameters Parameters passed to the action
   * @param {String} parameters.registryUrl The url for the Extension Registry Manager  (required)
   * @param {String} parameters.progressUpdateActionId ID of action in current chain to execute for providing
   *  progress update during extension downloads. In the executed action chain '$current' shall be available
   *  in the context to retrieve 'percent' indicating the progress, for e.g.  "{{ $current.percent }}" can
   *  be used to set the progress percentage
   *
   * @returns {Promise<Outcome<Object>>} A Promise with an Outcome containing a literal object with property "updated".
   * The object property "update""shall be true if there are extensions that were to be downloaded, otherwise false.
   * The result can be accessed in the action chain result using:
   * "$chain.results.[actionName].updated" for e.g."[[ $chain.results.downloadExtensions]].updated"
   *
   * An example of entry to download extension in a page descriptor:
   * "downloadExtensions": {
   *     "module": "vb/action/builtin/downloadExtensionsAction",
   *      "parameters": {
   *        "registryUrl": "https://fuscdrmsmc217-fa-ext.us.oracle.com:443/fscmUI/vxmanifest/v1/applications",
   *        "progressUpdateActionId": "updateProgress"
   *      },
   *      "outcomes": {
   *        "success": "hideDownloadScreen"
   *      }
   *    },
   * "updateProgress" : {
   *        "module": "vb/action/builtin/assignVariablesAction",
   *        "parameters": {
   *         "$page.variables.downloadPercent": {
   *           "source": "{{ $current.percent }}"
   *         }
   *       }
   *     }
   *
   *
   */
  class DownloadExtensionsAction extends Action {
    // eslint-disable-next-line class-methods-use-this
    perform(parameters) {
      let actionContext;
      if (parameters.progressUpdateActionId) {
        actionContext = ActionHelper.createNewContext(this.availableContexts, this);
      }

      return this.actionChain.context.application.extensionRegistry
        .downloadExtensions(parameters.registryUrl, parameters.progressUpdateActionId, this.actionChain, actionContext)
        .then((extensions) => Action.createSuccessOutcome({ updated: !!(extensions && extensions.length > 0) }))
        .catch((e) => Action.createFailureOutcome('Failed to download extensions', e));
    }

    /**
     * called by actionChain
     * @param actionChain
     * @param availableContexts
     */
    setContext(actionChain, availableContexts) {
      this.actionChain = actionChain;
      this.availableContexts = availableContexts;
    }
  }

  return DownloadExtensionsAction;
});

